<div class="container-margin">
  <h2>{{ translationService.getSettingsText() }}</h2>

  <mat-accordion displayMode="flat">
    <app-language></app-language>
    <app-location></app-location>
    @if (isAdmin || isComplianceOfficer) {
      <app-product-csv-templates></app-product-csv-templates>
      <app-ingredient-csv-templates></app-ingredient-csv-templates>
      <app-fpr-templates></app-fpr-templates>
      <app-product-sharing-templates></app-product-sharing-templates>
    }
  </mat-accordion>
</div>
